<div class="d-flex">
  <div
    class="item-row clickable"
    [ngClass]="itemBackgroundClass(item)"
    (click)="toggleSelected(item)"
  >
    <div class="item-cell flex-column" style="flex: 1.65;">
      <div>
        <b># {{ item.immoTask.id }}</b>
      </div>
    </div>
    <div class="item-cell flex-3">
      <b>Taak</b>
    </div>
    <div class="item-cell flex-4">
      {{ item.immoTask.requestingUser }}
    </div>
    <div class="item-cell flex-8">
      <b>{{ item.immoTask.subject | shortenText: 50 }}</b>
    </div>
    <div class="item-cell stock-cell flex-1"></div>
    <div class="item-cell" style="flex: 2.3;"></div>
  </div>
  <div
    class="reviewed-flag"
    [ngClass]="itemBackgroundClass(item)"
    [class.reviewed]="item.immoTask.atelierCheckboxes?.reviewed"
  ></div>
</div>
